import { PreloaderLogo } from "../../assets/images";

const Preloader = ({ loading }: { loading: boolean }) => {
  return loading ? (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="size-[200px]">
        <img src={PreloaderLogo} alt='preloader_logo'/>
      </div>
    </div>
  ) : null;
};

export default Preloader;
